// localStorage.js

export const loadLocaCartHashlState = () => {
  try {
    if (typeof window.wc_cart_fragments_params !== 'undefined') {
      const cart_hash_key = window.wc_cart_fragments_params.cart_hash_key;
      const serializedState = localStorage.getItem(cart_hash_key);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    }
  } catch (err) {
    return undefined;
  }
};

export const saveLocalCartHashState = (state) => {
  try {
  
    if (typeof window.wc_cart_fragments_params !== 'undefined') {
     
      const { fragment_name, cart_hash_key } = window.wc_cart_fragments_params;

      const serializedState = JSON.stringify(state);
      localStorage.setItem(cart_hash_key, serializedState);
   // const serializedState = JSON.stringify(state);
   // localStorage.setItem('ips_cart_store', serializedState);
    }
  } catch (err) {
    console.error("Can't save changes in local storage", err);
  }
};